// import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// main css
import "./scss/main.scss";

import scrollTopHandler from "./js/helpers/scrollTop";

import {
  headerSearchHandler,
  mobileMenuHandler,
  menuScrollChange,
  mobileMenuCollapseHandler,
} from "./js/helpers/menu";

import { linkGroupHandler } from "./js/helpers/fixedLink";

// 滑動向上按鈕監聽
scrollTopHandler();

// header search 功能
headerSearchHandler();

// 手機版 menu
mobileMenuHandler();
menuScrollChange();
mobileMenuCollapseHandler();
linkGroupGsap();

function linkGroupGsap() {
  const main = document.querySelector(`main`);
  const body = document.querySelector(`body`);

  // 匯集頁、qa 頁 需客制設定
  if (
    !main.classList.contains("archive") &&
    !body.classList.contains("page-id-397")
  ) {
    linkGroupHandler();
  }
}
